import i18n from '@/libs/i18n'

const { t } = i18n.global

enum Errors {
    InternalServerError = 1,
    InvalidData,
    NotFound,
    Unauthorized,
    UserExist,
    UserDoesNotExist,
    FailedToInsert,
    FileToBig,
    UnableToRetrieveExtension,
    NoAccess,
    EquipmentNotPurchased,
    IncorrectPassword,
    TaxNumberNotFound,
    TaxNumberCountryNotSpecified,
    TaxNumberInvalidData,
    TaxNumberError
}

const parseError = (errorObject: unknown, fallback = '') => {
    if (errorObject === null || errorObject === undefined
        || !(errorObject instanceof Object)
        || !('error' in errorObject)
        || !errorObject.error
        || !(errorObject.error instanceof Object)
        || !('code' in errorObject.error)
        || errorObject.error.code === Errors.InternalServerError) {
        if (fallback && fallback !== '') return fallback
        return t('errors.generic_error')
    }

    switch (errorObject.error.code) {
        case Errors.InvalidData:
            return t('errors.invalid_data')
        case Errors.NotFound:
            return t('errors.not_found')
        case Errors.Unauthorized:
            return t('errors.unauthorized')
        case Errors.UserExist:
            return t('errors.user_exist')
        case Errors.UserDoesNotExist:
            return t('errors.user_does_not_exist')
        case Errors.FailedToInsert:
            return t('errors.failed_to_insert')
        case Errors.FileToBig:
            return t('errors.file_to_big')
        case Errors.UnableToRetrieveExtension:
            return t('errors.unable_to_retrieve_extension')
        case Errors.NoAccess:
            return t('errors.no_access')
        case Errors.EquipmentNotPurchased:
            return t('errors.equipment_not_purchased')
        case Errors.IncorrectPassword:
            return t('errors.incorrect_password')
        case Errors.TaxNumberNotFound:
            return t('errors.tax_number_not_found')
        case Errors.TaxNumberCountryNotSpecified:
            return t('errors.tax_number_country_not_specified')
        case Errors.TaxNumberInvalidData:
            return t('errors.tax_number_invalid_data')
        case Errors.TaxNumberError:
            return t('errors.generic_error')
        default:
            return t('errors.generic_error')
    }
}

export { parseError }
